module.exports = __webpack_public_path__ + "static/media/options-outline.0f3d3040.svg";